import React from "react";

export default function LandingTab({ onPrimary }) {
  return (
    <div className="landing-tab">
      <div className="hero">
        <h1 className="hero-title">Alkeme UX</h1>

        <p className="hero-lead">
          We’re a next-generation software house delivering{" "}
          <b>fast, resilient</b>, and <b>beautifully crafted</b> systems — from
          local-first apps to modern web platforms.
        </p>

        <p className="hero-text">
          We redesign legacy code, optimise performance end-to-end, and keep
          your stack humming with world-class <b>24/7 support</b> and
          infrastructure management. No project is “too small” or “too hard” —
          we ship the work others avoid.
        </p>

        <p className="hero-text">
          Our approach is simple: <b>clarity</b> in requirements, <b>rigour</b>{" "}
          in engineering, and <b>measurable outcomes</b> in production. You
          focus on product and customers; we handle reliability, speed, and
          scalability.
        </p>

        <ul className="hero-list">
          <li>
            <b>Local-first & high-performance</b> systems with offline-safe data
            flows.
          </li>
          <li>
            <b>Modern web delivery</b>: React/TypeScript, secure APIs, and CI/CD
            done right.
          </li>
          <li>
            <b>Legacy modernisation</b>: refactors, rewrites, and zero-downtime
            migrations.
          </li>
          <li>
            <b>Observability & SRE</b>: metrics, tracing, alerts, and on-call
            you can trust.
          </li>
          <li>
            <b>Security by default</b>: principled auth, least-privilege, and
            hardened deploys.
          </li>
        </ul>

        <div className="hero-cta">
          <a
            className="btn secondary"
            href="mailto:hello@alkemeux.com?subject=Project%20Enquiry%20—%20Alkeme%20UX"
          >
            Start a Project
          </a>
        </div>

        <p className="hero-tagline">Build once. Run fast. Scale calmly.</p>
      </div>

      <style jsx>{`
        .hero {
          max-width: 820px;
          margin: 0 auto;
          padding: 40px 20px;
          text-align: center;
          line-height: 1.7;
        }
        .hero-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1.4rem;
          letter-spacing: -0.5px;
        }
        .hero-lead {
          font-size: 1.2rem;
          margin-bottom: 1.8rem;
          color: #d4d7e1;
        }
        .hero-text {
          margin: 1.4rem 0;
          color: #c5c9d6;
        }
        .hero-list {
          margin: 2rem auto;
          padding-left: 1.2rem;
          text-align: left;
          max-width: 680px;
          color: #cbd1dd;
          line-height: 1.6;
        }
        .hero-list li {
          margin: 0.8rem 0;
        }
        .hero-cta {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin: 2rem 0 1rem;
        }
        .btn {
          padding: 12px 20px;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.2s ease;
          text-decoration: none;
        }
        .btn:hover {
          transform: translateY(-2px);
        }
        .btn.primary {
          background: linear-gradient(180deg, #1b2333, #141a26);
          color: #fff;
          border: 1px solid #2b3242;
        }
        .btn.secondary {
          background: transparent;
          color: #61dafb;
          border: 1px solid #61dafb;
        }
        .hero-tagline {
          margin-top: 2rem;
          font-style: italic;
          color: #9da5b5;
        }
      `}</style>
    </div>
  );
}
